import { GET_MAPBOX, GET_MAPBOX_ERROR, GET_MAPBOX_SUCCESS } from './VisualizadorEspacial.actions'

const mapboxState = {
  loading: true,
  error: false,
  urlData: []
}

const mapboxReducer = (state = mapboxState, { payload, type }) => {
  switch (type) {
    case GET_MAPBOX: {
      return { ...state, loading: true, error: false }
    }
    case GET_MAPBOX_SUCCESS: {
      return { ...state, loading: false, error: false, urlData: payload.urlData }
    }
    case GET_MAPBOX_ERROR: {
      return { ...state, loading: false, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default mapboxReducer
